import * as React from 'react';
import { SVGProps } from 'react';

const IconUnlockSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3a1 1 0 0 1 2 0v1h-.47a.53.53 0 0 0-.53.53v5.94c0 .293.237.53.53.53h6.94a.53.53 0 0 0 .53-.53V4.53a.53.53 0 0 0-.53-.53H5V3a2 2 0 1 0-4 0v1h1V3Zm6.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    />
  </svg>
);
export default IconUnlockSizeXs;
